import { getDataBeforeTargetKey } from '@pages/Clients/ClientsList/utils';

import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

export const getFilterValuesRest: NClientsList.GetFilterValuesRest = ({
  type,
  filtersArea,
  filterGroupIndex,
  filters,
  serverFilters,
}) => {
  const filterValuesRest = (
    type === 'filters'
      ? getDataBeforeTargetKey({
          oldFilters: filters,
          filtersArea,
          filterGroupIndex,
        })
      : getDataBeforeTargetKey({
          oldFilters: serverFilters,
          filtersArea,
          filterGroupIndex,
        })
  )?.[0];

  return filterValuesRest;
};
